import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cb_form_text_with_image = _resolveComponent("cb-form-text-with-image")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_cb_form_text_with_image, {
        "can-copy-from-library": "",
        "cb-type": "BASIC_HOMEPAGE_META_ABSTRACT",
        "doc-type": "CB_TEXT_WITH_IMAGE_IMG",
        mode: $options.PageDetailModeEnum.EDIT,
        "is-clearable": "",
        "has-button-section": false,
        title: "Metadata",
        description: _ctx.$t('descriptionBasicHomepageMeta')
      }, null, 8, ["mode", "description"])
    ]),
    _: 1
  }))
}